import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  selectActiveCapabilities,
  type StateWithPsaps,
} from '../capstone/psapInfo/psapInfoSlice';

const PURE_WIRELESS_CAPABILITY = 'pure_wireless_0';

type StateWithAdditionalLayers = StateWithPsaps & {
  additionalLayers: AdditionalLayersState;
};

export interface AdditionalLayersState {
  pureWireless: {
    visible: boolean;
  };
}

const initialState: AdditionalLayersState = {
  pureWireless: {
    visible: false,
  },
};

const additionalLayersSlice = createSlice({
  name: 'additionalLayers',
  initialState,
  reducers: {
    togglePureWireless: state => {
      state.pureWireless.visible = !state.pureWireless.visible;
    },
    setPureWirelessVisible: (state, action: PayloadAction<boolean>) => {
      state.pureWireless.visible = action.payload;
    },
    clearAllAdditionalLayers: state => {
      state.pureWireless.visible = false;
    },
  },
});

export const {
  togglePureWireless,
  setPureWirelessVisible,
  clearAllAdditionalLayers,
} = additionalLayersSlice.actions;

// Selectors
export const selectPureWirelessVisible = (state: StateWithAdditionalLayers) => {
  const capabilities = selectActiveCapabilities(state);
  const hasCapability = Boolean(capabilities?.[PURE_WIRELESS_CAPABILITY]);
  return hasCapability && state.additionalLayers.pureWireless.visible;
};

export const selectAdditionalLayersCount = (
  state: StateWithAdditionalLayers,
) => (selectPureWirelessVisible(state) ? 1 : 0);

const persistConfig = {
  key: 'additionalLayers',
  storage,
};

export default persistReducer(persistConfig, additionalLayersSlice.reducer);
